import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const StarIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21Z'
                fill='currentColor'
            />
        </>
    ),
})

StarIcon.displayName = 'StarIcon'
